/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_ContentInputs */

const en_directory_submit_workspace_aside_content = /** @type {(inputs: Directory_Submit_Workspace_Aside_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete details`)
};

const zh_directory_submit_workspace_aside_content = /** @type {(inputs: Directory_Submit_Workspace_Aside_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填写详情`)
};

/**
* | output |
* | --- |
* | "Complete details" |
*
* @param {Directory_Submit_Workspace_Aside_ContentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_content = /** @type {((inputs?: Directory_Submit_Workspace_Aside_ContentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_ContentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_content(inputs)
	return zh_directory_submit_workspace_aside_content(inputs)
});
export { directory_submit_workspace_aside_content as "directory.submit.workspace.aside.content" }